var map = {
	"./TermoSupporter.html": "1a5c",
	"./app/CHANGELOG.txt": "f677",
	"./daumhelp/Agendamento": "5cb1",
	"./daumhelp/Agendamento.js": "5cb1",
	"./daumhelp/Atendemos": "7c5d",
	"./daumhelp/Atendemos.js": "7c5d",
	"./daumhelp/Atendimento": "3070",
	"./daumhelp/Atendimento.js": "3070",
	"./daumhelp/SemCobertura": "5ba6",
	"./daumhelp/SemCobertura.js": "5ba6",
	"./daumhelp/footer.php": "a469",
	"./daumhelp/index.html": "b5b7b",
	"./daumhelp/page (cópia).php": "8c45",
	"./daumhelp/page.php": "8d8c",
	"./daumhelp/token": "3826",
	"./favicon.ico": "05fd",
	"./fonts/gill-sans.otf": "cd29",
	"./fonts/verdana.ttf": "1b90",
	"./img/icons/android-chrome-192x192.png": "43b0",
	"./img/icons/android-chrome-512x512.png": "ba42",
	"./img/icons/apple-touch-icon-120x120.png": "a4e8",
	"./img/icons/apple-touch-icon-152x152.png": "69eb",
	"./img/icons/apple-touch-icon-180x180.png": "d5be",
	"./img/icons/apple-touch-icon-60x60.png": "85fc",
	"./img/icons/apple-touch-icon-76x76.png": "1086",
	"./img/icons/apple-touch-icon.png": "1ccc",
	"./img/icons/favicon-16x16.ico": "98d6",
	"./img/icons/favicon-16x16.png": "058f",
	"./img/icons/favicon-32x32.ico": "4dbd",
	"./img/icons/favicon-32x32.png": "730b",
	"./img/icons/favicon.ico": "7973",
	"./img/icons/msapplication-icon-144x144.png": "647c",
	"./img/icons/mstile-150x150.png": "5b7d",
	"./img/icons/safari-pinned-tab.svg": "7dc5",
	"./index.html": "cb67",
	"./js/clicksign": "53158",
	"./js/clicksign.js": "53158",
	"./json/cidades": "b608",
	"./json/cidades.json": "b608",
	"./manifest": "4d99",
	"./manifest.json": "4d99",
	"./robots.txt": "86c8",
	"./templates/template-cliente.csv": "43a9",
	"./theme/ns/chat-ns.css": "80c2",
	"./theme/ns/logo.svg": "39e8",
	"./theme/ns/style-ns.scss": "b32c",
	"./theme/vero/chat-vero.css": "986c",
	"./theme/vero/favicon.ico": "719c",
	"./theme/vero/logo.svg": "696d",
	"./theme/vero/style-vero.scss": "e031"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b89";